export default __webpack_public_path__ + "static/media/ca8aa668c95c836ecd9b649b137a94261579550954748.23e590b0.webp";